import { CSSProperties, ReactNode } from "react";

type Props = {
  label: string;
  hint?: string;
  children: ReactNode;
  align?: CSSProperties["alignItems"];
};

export function SettingsRow({ label, hint, children, align = "center" }: Props) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(200px, 280px) 1fr",
        gap: 24,
        padding: "14px 0",
        borderBottom: "1px solid var(--border)",
        alignItems: align,
      }}
    >
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--fg)" }}>{label}</div>
        {hint && (
          <div
            style={{
              fontSize: 11,
              color: "var(--fg-muted)",
              marginTop: 3,
              lineHeight: 1.5,
            }}
          >
            {hint}
          </div>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
}

export const S_INPUT: CSSProperties = {
  width: "100%",
  maxWidth: 360,
  padding: "7px 11px",
  border: "1px solid var(--border-strong)",
  borderRadius: 8,
  fontFamily: "var(--font-body)",
  fontSize: 13,
  color: "var(--fg)",
  background: "var(--bg-card)",
  outline: "none",
  boxSizing: "border-box",
};
